<template>
    <div class="d-flex flex-column">
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <h6 style="padding-left: 15px;">Редактирование расчёта #{{ item.id }}</h6>
            <div>
                <button class="btn btn-outline-green mr-3" @click="cancelEditItem">
                    Отмена
                </button>
                <button class="btn btn-outline-green" @click="saveEditItem">
                    Сохранить
                </button>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col">
                <b-form-checkbox
                    v-model="item.input_percent"
                    name="short_order-check-button"
                    :value="1"
                    :unchecked-value="0"
                    switch
                >
                    <b>% от входящей суммы</b>
                </b-form-checkbox>                
                <b-form-checkbox
                    v-model="item.hand_mode"
                    name="short_order-check-button"
                    :value="1"
                    :unchecked-value="0"
                    switch
                >
                    <b>Отключить формулы</b>
                </b-form-checkbox>
            </div>            
            <div class="col text-right">
                <em style="font-size: 11px;">Курс валют: USD {{cbr.USD || '--'}}, EUR {{cbr.EUR || '--'}}, CNY {{cbr.CNY || '--'}}, TRY {{cbr.TRY || '--'}}, AMD {{cbr.AMD || '--'}}, AED {{cbr.AED || '--'}}</em>
            </div>
        </div>

        <b-container class="line-height">
            <b-row class="align-items-end mb-4">
                <b-col sm="6" md="2">
                    <label class="my-2" for="currency">Валюта</label>
                    <b-form-select id="currency" style="height: 50px;" v-model="item.currency" :options="options" />
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="purchase_rate">Курс покупки валюты на дату</label>
                    <b-form-datepicker
                        id="purchase_rate"
                        locale="ru-RU"
                        today-button
                        label-today-button="Сегодня"
                        reset-button
                        label-reset-button="Сбросить"
                        placeholder="Выберите дату"
                        :date-format-options="dateOptions"
                        v-model="purchase_rate"
                        @change="translateDate"
                    />
                </b-col>
                <b-col sm="6" md="2">
                    <label class="my-2" for="exchange_rate">Курс валюты на {{ item.purchase_rate }}</label>
                    <b-form-input v-dot-replace id="exchange_rate" type="text" v-model="item.exchange_rate" />
                </b-col>
                <b-col sm="6" md="2">
                    <label class="my-2" for="difference">Курсовая разница, %</label>
                    <b-form-input v-dot-replace id="difference" type="text" v-model="item.difference" />
                </b-col>
                <b-col sm="6" md="2">
                    <label class="my-2" for="percentage_of_agency_commission">Процент агентской комиссии, %</label>
                    <b-form-input v-dot-replace id="percentage_of_agency_commission" type="text" v-model="item.percentage_of_agency_commission" />
                </b-col>
            </b-row>
            <hr />
            <b-row class="align-items-end my-4">
                <b-col sm="6" md="3">
                    <label class="my-2" for="cost">Стоимость товара</label>
                    <b-form-input v-dot-replace id="cost" type="text" v-model="item.cost" />
                </b-col>
                <b-col sm="6" md="3">
                    <label class="my-2" for="feasibility_study_to_the_border">ТЭО до границы ТС</label>
                    <b-form-input v-dot-replace id="feasibility_study_to_the_border" type="text" v-model="item.feasibility_study_to_the_border" />
                </b-col>
                <b-col sm="6" md="3">
                    <div class="my-2">Итого стоимость товара с ТЭО</div>
                    <b-form-input v-dot-replace id="input_total_cost_feasibility_study" type="text" v-if="item.hand_mode" v-model="item.total_cost_feasibility_study" />
                    <span class="form-control bg-light" v-if="!item.hand_mode">{{ item.total_cost_feasibility_study }}</span>
                </b-col>
                <b-col sm="6" md="3">
                    <label class="my-2" for="customs_duty">Таможенный сбор</label>
                    <b-form-input v-dot-replace id="customs_duty" type="text" v-model="item.customs_duty" />
                </b-col>
                <b-col sm="6" md="3">
                    <label class="my-2" for="customs_fee">Таможенная пошлина</label>
                    <b-form-input v-dot-replace id="customs_fee" type="text" v-model="item.customs_fee" />
                </b-col>
                <b-col sm="6" md="3">
                    <div class="my-2">НДС на Таможне</div>
                    <b-form-input v-dot-replace id="input_vat_at_customs" type="text" v-if="item.hand_mode" v-model="item.vat_at_customs" />
                    <span class="form-control bg-light" v-if="!item.hand_mode">{{ item.vat_at_customs }}</span>
                </b-col>
                <b-col sm="6" md="3">
                    <div class="my-2">Итого стоимость товара без НДС</div>
                    <b-form-input v-dot-replace id="input_cost_without_vat" type="text" v-if="item.hand_mode" v-model="item.cost_without_vat" />
                    <span class="form-control bg-light" v-if="!item.hand_mode">{{ item.cost_without_vat }}</span>
                </b-col>
                <template v-if="item.input_percent == 1">
                    <b-col sm="6" md="3">
                        <div class="my-2">% от входящей суммы</div>
                        <b-form-input v-dot-replace id="input_percent_sum" type="text" v-model="item.input_percent_sum" />
                    </b-col>
                </template>
            </b-row>
            <hr />
            <b-row class="align-items-end my-4">
                <b-col sm="6" md="4">
                    <div class="my-2">Покупка валюты<br />и оплата за товар и ТЭО</div>
                    <b-form-input v-dot-replace id="input_purchase_of_currency" type="text" v-if="item.hand_mode" v-model="item.purchase_of_currency" />
                    <span class="form-control bg-light overflow-auto" v-if="!item.hand_mode">{{ item.purchase_of_currency }}</span>
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="feasibility_study_on_territory_rub">ТЭО по территории ТС, руб.</label>
                    <b-row class="align-items-center">
                        <b-col sm="6">
                            <b-form-input 
                                id="feasibility_study_on_territory_rub" 
                                :disabled="!item.hand_mode && (item.exchange_rate == 0 || item.exchange_rate == '')" 
                                type="text" 
                                v-dot-replace
                                v-model="item.feasibility_study_on_territory_rub"
                            />
                        </b-col>
                        <b-col sm="6">
                            <span class="form-control bg-light overflow-auto">{{ item.feasibility_study_on_territory }}</span>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="customs_clearance_rub">Таможенное оформление, руб.</label>
                    <b-row class="align-items-center">
                        <b-col sm="6">
                            <b-form-input 
                                id="customs_clearance_rub" 
                                :disabled="!item.hand_mode && (item.exchange_rate == 0 || item.exchange_rate == '')" 
                                type="text" 
                                v-dot-replace
                                v-model="item.customs_clearance_rub"
                            />
                        </b-col>
                        <b-col sm="6">
                            <span class="form-control bg-light overflow-auto">{{ item.customs_clearance }}</span>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="permits_rub">Разрешительные документы, руб.</label>
                    <b-row class="align-items-center">
                        <b-col sm="6">
                            <b-form-input 
                                id="permits_rub"
                                :disabled="!item.hand_mode && (item.exchange_rate == 0 || item.exchange_rate == '')" 
                                type="text" 
                                v-dot-replace
                                v-model="item.permits_rub"
                            />
                        </b-col>
                        <b-col sm="6">
                            <span class="form-control bg-light overflow-auto">{{ item.permits }}</span>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="cargo_insurance_rub">Страхование груза, руб.</label>
                    <b-row class="align-items-center">
                        <b-col sm="6">
                            <b-form-input 
                                id="cargo_insurance_rub" 
                                :disabled="!item.hand_mode && (item.exchange_rate == 0 || item.exchange_rate == '')" 
                                type="text" 
                                v-dot-replace
                                v-model="item.cargo_insurance_rub"
                            />
                        </b-col>
                        <b-col sm="6">
                            <span class="form-control bg-light overflow-auto">{{ item.cargo_insurance }}</span>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" md="4">
                    <label class="my-2" for="terminal_rashod_rub">Терминальные расходы, руб.</label>
                    <b-row class="align-items-center">
                        <b-col sm="6">
                            <b-form-input 
                                id="terminal_rashod_rub" 
                                :disabled="!item.hand_mode && (item.exchange_rate == 0 || item.exchange_rate == '')" 
                                type="text" 
                                v-dot-replace
                                v-model="item.terminal_rashod_rub"
                            />
                        </b-col>
                        <b-col sm="6">
                            <span class="form-control bg-light overflow-auto">{{ item.terminal_rashod }}</span>
                        </b-col>
                    </b-row>
                </b-col>                
                <b-col sm="6" md="4">
                    <div class="my-2">Агентские услуги, комиссия за техимпортера</div>
                    <b-form-input v-dot-replace id="input_agency_services" type="text" v-if="item.hand_mode" v-model="item.agency_services" />
                    <span class="form-control bg-light overflow-auto" v-if="!item.hand_mode">{{ item.agency_services }}</span>
                </b-col>
                <b-col sm="6" md="4">
                    <div class="my-2">Себестоимость товара</div>
                    <b-form-input v-dot-replace id="input_cost_of_goods" type="text" v-if="item.hand_mode" v-model="item.cost_of_goods" />
                    <span class="form-control bg-light overflow-auto" v-if="!item.hand_mode">{{ item.cost_of_goods }}</span>
                </b-col>
                <b-col sm="6" md="4">
                    <div class="my-2">НДС</div>
                    <b-form-input v-dot-replace id="input_vat" type="text" v-if="item.hand_mode" v-model="item.vat" />
                    <span class="form-control bg-light overflow-auto" v-if="!item.hand_mode">{{ item.vat }}</span>
                </b-col>
                <b-col sm="6" md="4">
                    <div class="my-2">Стоимость с НДС</div>
                    <b-form-input v-dot-replace id="input_cost_with_vat" type="text" v-if="item.hand_mode" v-model="item.cost_with_vat" />
                    <span class="form-control bg-light overflow-auto" v-if="!item.hand_mode">{{ item.cost_with_vat }}</span>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { API_STATISTIC } from '@/constants';

export default {  
    props: {
        copyItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            cbr: {},
            options: [
                {
                    value: 'USD',
                    text: 'USD'
                },
                {
                    value: 'EUR',
                    text: 'EUR'
                },
                {
                    value: 'CNY',
                    text: 'CNY'
                },
                {
                    value: 'TRY',
                    text: 'TRY'
                },
                {
                    value: 'AMD',
                    text: 'AMD'
                },
                {
                    value: 'AED',
                    text: 'AED'
                },
                {
                    value: 'RUB',
                    text: 'RUB'
                },
            ],
            dateOptions: {
                'year': 'numeric',
                'month': '2-digit',
                'day': '2-digit'
            },
            purchase_rate: new Date(),
            customs_clearance: 0,
            item: {},
        }
    },
    directives: {
        'dot-replace': {
            bind(el) {
                el.addEventListener('change', function() {
                let originalType = el.type;
                el.type = 'text';  // Temporarily change type to text
                el.value = el.value.replace(/,/g, '.');
                el.type = originalType;  // Change back to the original type
                // Trigger input event to update v-model
                el.dispatchEvent(new Event('input'));
                });
            }
        }
    },
    watch: {
        item: {
            handler() {
                if (this.item.hand_mode != 1) {
                    this.item.total_cost_feasibility_study = this.roundToTwo(+this.item.cost + +this.item.feasibility_study_to_the_border);
                    this.item.cost_without_vat = this.roundToTwo(+this.item.total_cost_feasibility_study + +this.item.customs_duty + +this.item.customs_fee);
                    this.item.vat_at_customs = this.roundToTwo(+this.item.cost_without_vat * 20 / 100);
                    this.item.purchase_of_currency = this.roundToTwo(+this.item.total_cost_feasibility_study * +this.item.difference / 100);
                    this.item.vat = this.roundToTwo(+this.item.cost_of_goods * 20 / 100);
                    this.item.cost_with_vat = this.roundToTwo(+this.item.cost_of_goods + +this.item.vat);
                                        
                    this.item.agency_services = 
                        this.roundToTwo(
                            (+this.item.total_cost_feasibility_study + 
                            +this.item.customs_duty + 
                            +this.item.customs_fee + 
                            // +this.item.vat_at_customs + 
                            +this.item.customs_clearance + 
                            +this.item.permits + 
                            +this.item.cargo_insurance + 
                            +this.item.terminal_rashod + 
                            +this.item.purchase_of_currency + 
                            +this.item.feasibility_study_on_territory) * 
                            +this.item.percentage_of_agency_commission / 100) + +this.item.input_percent_sum;

                    this.item.cost_of_goods = 
                        this.roundToTwo(
                            +this.item.cost_without_vat + 
                            +this.item.purchase_of_currency + 
                            +this.item.feasibility_study_on_territory +
                            +this.item.customs_clearance + 
                            +this.item.permits +
                            +this.item.cargo_insurance + 
                            +this.item.terminal_rashod + 
                            +this.item.agency_services);

                    this.onCheckExchangeRate();
                }
            },
            deep: true
        },
        'item.input_percent': {
            handler(value) {
                if (value == 0) {
                    this.item.input_percent_sum = 0;
                }
            }
        },
        'item.exchange_rate': {
            handler() {
                // this.item.feasibility_study_on_territory = this.roundToTwo(this.item.feasibility_study_on_territory_rub / this.item.exchange_rate / 12 * 10);
                // this.item.customs_clearance = this.roundToTwo(this.item.customs_clearance_rub / this.item.exchange_rate / 12 * 10);
                // this.item.permits = this.roundToTwo(this.item.permits_rub / this.item.exchange_rate / 12 * 10);
                // this.item.cargo_insurance = this.roundToTwo(this.item.cargo_insurance_rub / this.item.exchange_rate);
                // this.item.terminal_rashod = this.roundToTwo(this.item.terminal_rashod_rub / this.item.exchange_rate);
                this.item.feasibility_study_on_territory = this.roundToTwo(this.item.feasibility_study_on_territory_rub / this.item.exchange_rate);
                this.item.customs_clearance = this.roundToTwo(this.item.customs_clearance_rub / this.item.exchange_rate);
                this.item.permits = this.roundToTwo(this.item.permits_rub / this.item.exchange_rate);
                this.item.cargo_insurance = this.roundToTwo(this.item.cargo_insurance_rub / this.item.exchange_rate);
                this.item.terminal_rashod = this.roundToTwo(this.item.terminal_rashod_rub / this.item.exchange_rate);
            }
        },
        'item.feasibility_study_on_territory_rub': {
            handler() {
                // this.item.feasibility_study_on_territory = this.roundToTwo(this.item.feasibility_study_on_territory_rub / this.item.exchange_rate / 12 * 10);
                this.item.feasibility_study_on_territory = this.roundToTwo(this.item.feasibility_study_on_territory_rub / this.item.exchange_rate);
            }
        },
        'item.customs_clearance_rub': {
            handler() {
                // this.item.customs_clearance = this.roundToTwo(this.item.customs_clearance_rub / this.item.exchange_rate / 12 * 10);
                this.item.customs_clearance = this.roundToTwo(this.item.customs_clearance_rub / this.item.exchange_rate);
            }
        },
        'item.permits_rub': {
            handler() {
                // this.item.permits = this.roundToTwo(this.item.permits_rub / this.item.exchange_rate / 12 * 10);
                this.item.permits = this.roundToTwo(this.item.permits_rub / this.item.exchange_rate);
            }
        },
        'item.cargo_insurance_rub': {
            handler() {
                this.item.cargo_insurance = this.roundToTwo(this.item.cargo_insurance_rub / this.item.exchange_rate);
            }
        },
        'item.terminal_rashod_rub': {
            handler() {
                this.item.terminal_rashod = this.roundToTwo(this.item.terminal_rashod_rub / this.item.exchange_rate);
            }
        },
        purchase_rate: {
            handler() {
                if (this.purchase_rate) {
                    this.item.purchase_rate = this.translateDate(this.purchase_rate);
                } else {
                    this.item.purchase_rate = this.translateDate(new Date());
                }
            }
        },
    },

    methods: {
        getCurrencyData() {
            api.call('get', API_STATISTIC)
                .then(({data}) => {
                    this.cbr = data.cbr
                });
        },

        translateDate(data) {
            let date = new Date(data);
            return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
        },

        roundToTwo(num) {
            return +(Math.round(num + "e+2") + "e-2");
        },

        onCheckExchangeRate() {
            if (this.item.exchange_rate == 0 || this.item.exchange_rate == '') {
                this.item.feasibility_study_on_territory_rub = 0;
                this.item.feasibility_study_on_territory = 0;

                this.item.customs_clearance_rub = 0;
                this.item.customs_clearance = 0;

                this.item.permits_rub = 0;
                this.item.permits = 0;

                this.item.cargo_insurance_rub = 0;
                this.item.cargo_insurance = 0;

                this.item.terminal_rashod_rub = 0;
                this.item.terminal_rashod = 0;
            }
        },

        convertDateForJs(data) {
            let newDate = data.split('.');
            [newDate[0], newDate[1]] = [newDate[1], newDate[0]];
            newDate = newDate.join('/');
            return new Date(newDate)
        },

        cancelEditItem() {
            this.$emit('cancelEditItem');
        },

        saveEditItem() {
            this.$emit('saveEditItem', this.item);
        }
    },

    mounted() {
        this.item = Object.assign({}, this.copyItem);
        if (!this.item.hand_mode) {
            this.$set(this.item, 'hand_mode', 0);
        }
        if (!this.item.input_percent) {
            this.$set(this.item, 'input_percent', 0);
            this.$set(this.item, 'input_percent_sum', 0);
        }
        if (!this.item.terminal_rashod_rub) {
            this.$set(this.item, 'terminal_rashod_rub', 0);
            this.$set(this.item, 'terminal_rashod', 0);
        }

        this.getCurrencyData();
        this.purchase_rate = this.convertDateForJs(this.item.purchase_rate);
    }
}
</script>